import createAction from '../services/create-action';
export var MEDIA_STUDIO_OPENED = 'mediaStudio/OPENED';
export var mediaStudioOpened = createAction(MEDIA_STUDIO_OPENED);
export var RCE_FILE_UPLOADED = 'rce/FILE_UPLOADED';
export var fileUploaded = createAction(RCE_FILE_UPLOADED);
export var RCE_FILE_DOWNLOADED = 'rce/FILE_DOWNLOADED';
export var fileDownloaded = createAction(RCE_FILE_DOWNLOADED);
